import { updateConfigValues } from '../actions/config';

const handlerName = 'SetEntryPoint';

function handler(payload, store) {
  const { entryPoint } = payload;
  store.dispatch(
    updateConfigValues({
      entryPoint,
    }),
  );
}

export { handlerName, handler };
